'use client';
import { twMerge } from 'tailwind-merge';
import { type ReactNode } from 'react';

interface HeaderMenuProps {
  children: ReactNode;
  className?: string;
}

const HeaderMenu = ({ children, className }: HeaderMenuProps) => {
  return (
    <nav data-component-id="src/components/ui/HeaderMenu.tsx:12:4" data-component-path="src/components/ui/HeaderMenu.tsx" data-component-line="12" data-component-end-line="21" data-component-file="HeaderMenu.tsx" data-component-name="nav" data-component-content="%7B%22elementName%22%3A%22nav%22%7D"
      className={twMerge(
        'flex items-center gap-6 md:gap-8 lg:gap-[38px]',
        className
      )}
      role="navigation"
      aria-label="Main navigation"
    >
      {children}
    </nav>
  );
};

export default HeaderMenu;